import { useQuery } from '@tanstack/react-query';
import { vehicleRegistrationKeys } from '../services/queryKeys';
import { fetchVehicleRegistration } from '../services/vehicleRegistration';

export const isClientError = (error: unknown): boolean => {
    const status = (error as { response?: { status?: number } } | undefined)?.response?.status;

    return typeof status === 'number' && status >= 400 && status < 500;
};

/** A 403 is the server's settled answer, so an ungated caller spends one request and not four. */
export function useVehicleRegistrationQuery(vehicleId: string | undefined) {
    return useQuery({
        queryKey: vehicleRegistrationKeys.detail(vehicleId ?? ''),
        queryFn: () => fetchVehicleRegistration(vehicleId!),
        enabled: !!vehicleId,
        retry: (count, error) => !isClientError(error) && count < 2,
    });
}
